import { render, staticRenderFns } from "./ThirdPartyLogin.vue?vue&type=template&id=45b9b785"
import script from "./ThirdPartyLogin.vue?vue&type=script&lang=js"
export * from "./ThirdPartyLogin.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyLogin.vue?vue&type=style&index=0&id=45b9b785&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports